export default __webpack_public_path__ + "static/media/qr_icon.31fb7f21.svg";